import React, { useEffect } from 'react';
import styled from 'styled-components';

const WhitepaperContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  background: #ffffff;
  overflow: hidden;
`;

const PDFContainer = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  
  @media (max-width: 768px) {
    height: 100vh;
    height: 100dvh; /* Use dynamic viewport height for mobile */
  }
`;

const PDFObject = styled.object`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  margin: 0;
  padding: 0;
`;

const PDFEmbed = styled.embed`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  margin: 0;
  padding: 0;
`;

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background: #ffffff;
  color: #000000;
  text-align: center;
`;

const FallbackText = styled.p`
  margin-bottom: 20px;
  font-size: 16px;
  color: #333333;
`;

const DownloadButton = styled.a`
  display: inline-block;
  margin: 10px;
  padding: 12px 24px;
  background: #000000;
  border: 1px solid #000000;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    background: #333333;
    border-color: #333333;
  }
  
  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
    width: 100%;
    max-width: 280px;
  }
`;

const WhitepaperPage: React.FC = () => {
  useEffect(() => {
    // Set body to white background for PDF viewing
    document.body.style.background = '#ffffff';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.documentElement.style.background = '#ffffff';
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
    
    return () => {
      // Cleanup: reset to default on unmount
      document.body.style.background = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.documentElement.style.background = '';
      document.documentElement.style.margin = '';
      document.documentElement.style.padding = '';
    };
  }, []);

  return (
    <WhitepaperContainer>
      <PDFContainer>
        <PDFObject
          data="/whitepaper.pdf#toolbar=1&navpanes=1&scrollbar=1"
          type="application/pdf"
          aria-label="Mavrk Whitepaper"
        >
          <PDFEmbed
            src="/whitepaper.pdf#toolbar=1&navpanes=1&scrollbar=1"
            type="application/pdf"
          />
          <FallbackContainer>
            <FallbackText>
              Your browser does not support embedded PDFs.
            </FallbackText>
            <DownloadButton
              href="/whitepaper.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              📄 Open PDF in New Tab
            </DownloadButton>
            <DownloadButton
              href="/whitepaper.pdf"
              download="Mavrk-Whitepaper-Dec-2025.pdf"
            >
              📥 Download PDF
            </DownloadButton>
          </FallbackContainer>
        </PDFObject>
      </PDFContainer>
    </WhitepaperContainer>
  );
};

export default WhitepaperPage;

